import http from '@/http'

export async function deleteDraftPage (draftPageId: number): Promise<any> {
  await http.delete(`/admin/draft-pages/${draftPageId}`)
}
